<template>
  <div class="md-layout include-past-row">
    <div class="md-layout-item md-size-70">
      <md-switch v-model="includePastProxy" :disabled="loading">
        Include past departures
      </md-switch>
    </div>
    <div class="md-layout-item md-size-30 text-right">
      <md-button
        class="md-primary md-dense"
        :disabled="actionLoading"
        @click="$emit('add')"
      >
        <md-icon>add</md-icon>
        Add Reservation
      </md-button>
      <md-button
        class="md-primary md-dense top-action-button"
        :disabled="loading || !hasRows"
        @click="$emit('download')"
      >
        <md-icon>description</md-icon>
        Download CSV
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReservationsToolbar",
  props: {
    includePast: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    actionLoading: {
      type: Boolean,
      default: false
    },
    hasRows: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    includePastProxy: {
      get() {
        return this.includePast;
      },
      set(value) {
        this.$emit("update:includePast", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.include-past-row {
  margin-bottom: 0.5rem;
}

.top-action-button {
  margin-left: 6px;
}
</style>
